var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",style:('background-image:url('+_vm.avatar+')')})
}
var staticRenderFns = []

export { render, staticRenderFns }